import { useCurrentUser } from 'hooks/auth';

/**
 * Hook to check if SMS (Vonage) integration is enabled for the current company.
 *
 * @returns boolean - true if Vonage is enabled for the company, false otherwise
 */
export const useIsVonageEnabled = (): boolean => {
  const { data, isCompany } = useCurrentUser();

  if (!isCompany) {
    return false;
  }

  return data?.currentCompanyUser?.company?.is_vonage_enabled ?? false;
};
